export default __webpack_public_path__ + "static/media/charging_together.36229a4b.png";